import React from 'react'

const ShortlistedTemplate = ({ data }) => {
  const {
    studentName = '',
    companyName = '',
    roundName = '',
    prevRoundName = '',
    signatureName = 'John Doe',
    signatureRole = 'Placement Coordinator',
    signatureInstitute = 'ABC Engineering College',
    signatureContact = '+91 9876543210',
    roleName = ''
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Hi {studentName},</p>
     
      <p style={{paddingTop:'8px'}}>
        This is to inform you that you've been moved to the next {roundName} round at {companyName} after 
        having cleared the {prevRoundName} round recently.
      </p>
     
      <p style={{paddingTop:'8px'}}>
        You will be informed on the next step of the evaluation process shortly.
      </p>
   
      <p style={{paddingTop:'10px', paddingBottom:'2px', margin:'0px'}}>Best regards,</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureName}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureRole}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureInstitute}</p>
      <p style={{paddingTop:'2px', paddingBottom:'2px', margin:'0px'}}>{signatureContact}</p>
    </div>
  )
}

export default ShortlistedTemplate
